import { Grid, Row } from 'antd'
import ModalContent from 'app/components/Core/Document/Modal'
import Table from 'app/components/Core/Document/Table'
import ProjectDocumentList from 'app/components/Core/Project/DocumentList'
import Button from 'app/components/UI-Elements/General/Button'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import * as React from 'react'

type Props = {
  project: IProject
}

const Document: React.FC<Props> = ({ project }) => {
  const {
    drawerfy: { open: openDrawer },
    modalify: { open }
  } = useFeedbacker()
  const { md } = Grid.useBreakpoint()

  const onUploadDocumentClick = () => {
    openDrawer({
      content: <ProjectDocumentList member={project} />,
      recordType: RecordType.document,
      action: 'create',
      width: 500,
      destroyOnClose: true
    })
  }

  const openDocument = (document: IDocument) => {
    open({
      content: <ModalContent document={document} />,
      title: document?.name,
      modalType: 'info',
      width: md ? '60vw' : undefined,
      destroyOnClose: true
    })
  }

  return (
    <Row>
      <KCol card={md} span={24}>
        <Row gutter={[0, 12]}>
          <KCol card={!md} span={24} loading={!project}>
            <If condition={project}>
              <Table
                onRowClick={(document) => openDocument(document)}
                params={{ project_id: project.id, legacy: true }}
                tableExtra={
                  <Button
                    onClick={onUploadDocumentClick}
                    title={'Dokument Hochladen'}
                    type="secondary"
                    block={!md}
                    disabled={!project}
                  />
                }
              />
            </If>
          </KCol>
        </Row>
      </KCol>
    </Row>
  )
}

export default Document
